<template>
  <div id="nom_intro_event_not_started">
    
    <h4>Nominations coming soon!</h4>

    <!-- COUNTDOWN
    11/05/2018 12:00 AM UTC-0400
     -->
    <countdown
    :target_date="nomination_start_date"
    title="Nominations start in:"
    ></countdown>

    <p>
      Soon you'll be able to nominate your favorite local restaurants, foods, people, services, places, and more to help them earn a spot as a Best of Dayton finalist this year. 
    </p>

  </div>
</template>

<script>
import Countdown from '@/features/countdown/countdown_timer.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);

export default {
  name: 'nom_intro_event_not_started',
  props: [
    'nom_start_date',
    'tz_offset'
  ],
  data () {
    return {
      
    }
  },
  computed: {
    nomination_start_date: function() {
      let vm = this;
      let start = '';

      if(vm.nom_start_date) {
        start = this.$root.store.manipulation_helpers.get_human_datetime(vm.nom_start_date, vm.tz_offset);
      }

      return start;
    }
  },
  methods: {

  },
  components: {
    Countdown
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/features/nominate/intros/nom_intro_event_not_started.vue